import { TIcon } from "@components/Icon/types";
import React, { FC } from "react";

const Icon: FC<TIcon> = ({ icon: Icon, ...rest }) => <Icon {...rest} />;

export { Icon };
